export default "__VITE_ASSET__BarhB5QH__"